import { Grid, Paper, TextField } from '@material-ui/core';
import React from 'reactn';
import { NumberField } from '../../components/NumberField';
import { SectionTitle } from '../../components/SectionTitle';
import { globalStyles } from '../../style/GlobalStyles';
import { SimulazioniSrlInputProps } from './DatiSimulazioniSrl';

export default function NormaleSimulazioniSrl(props: SimulazioniSrlInputProps) {
    const gClasses = globalStyles();

    const { state } = props;

    return (
        <React.Fragment>
            <Paper className={gClasses.mainPaper}>
            <SectionTitle primary={true} text="1° Simulazione - società non trasparente - nessun compenso agli amministratori - nessun dividendo"></SectionTitle>
                <SectionTitle text="Società"></SectionTitle>
                <TextField
                    name="C4"
                    label="Ragione sociale"
                    value={state.datiSimulazioniSrl.G48}
                    className={gClasses.longTextFieldReadOnly}
                    InputLabelProps={{
                        shrink: true,
                        disabled: true
                    }}
                    inputProps={{tabIndex: -1}}
                    margin="normal"
                />
                <Grid container spacing={3}>
                    <Grid item>
                        <NumberField
                            name="I6"
                            label="Utile di bilancio al lordo dell'IRES"
                            value={Number(state.datiSimulazioniSrl.K62)}
                            className={gClasses.textFieldReadOnly}
                            readOnly={true}
                        />
                    </Grid>
                    <Grid item>
                        <NumberField
                            name="I9"
                            label="Variazioni fiscali in aumento"
                            value={Number(state.datiSimulazioniSrl.K63)}
                            className={gClasses.textFieldReadOnly}
                            readOnly={true}
                        />
                    </Grid>
                    <Grid item>
                        <NumberField
                            name="I10"
                            label="Variazioni fiscali in diminuzione"
                            value={Number(state.datiSimulazioniSrl.K64)}
                            className={gClasses.textFieldReadOnly}
                            readOnly={true}
                        />
                    </Grid>
                    <Grid item>
                        <NumberField
                            name="I11"
                            label="Reddito d'impresa - fiscale"
                            value={Number(state.normaleSimulazioniSrl.I11)}
                            className={gClasses.textFieldReadOnly}
                            readOnly={true}
                        />
                    </Grid>
                    <Grid item>
                        <NumberField
                            name="I12"
                            label="Imponibile IRES"
                            value={Number(state.normaleSimulazioniSrl.I12)}
                            className={gClasses.textFieldReadOnly}
                            readOnly={true}
                        />
                    </Grid>
                    <Grid item>
                        <NumberField
                            name="I13"
                            label="IRES"
                            value={Number(state.normaleSimulazioniSrl.I13)}
                            className={gClasses.textFieldReadOnly}
                            readOnly={true}
                            special={true}
                        />
                    </Grid>
                    <Grid item>
                        <NumberField
                            name="I14"
                            label="Utile di bilancio"
                            value={Number(state.normaleSimulazioniSrl.I14)}
                            className={gClasses.textFieldReadOnly}
                            readOnly={true}
                        />
                    </Grid>
                </Grid>
            </Paper>
            <Paper className={gClasses.mainPaper}>
                <SectionTitle primary={true} text="1° Socio"></SectionTitle>
                <TextField
                    name="D20"
                    label="Nome"
                    value={state.datiSimulazioniSrl.C52}
                    className={gClasses.textFieldReadOnly}
                    InputLabelProps={{
                        shrink: true,
                        disabled: true
                    }}
                    inputProps={{tabIndex: -1}}
                    margin="normal"
                />
                <SectionTitle text="Redditi"></SectionTitle>
                <Grid container>
                    <NumberField
                        name="E23"
                        label="Pensione"
                        value={Number(state.datiSimulazioniSrl.E118)}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E24"
                        label="Lav. dipendente e assimilati"
                        value={Number(state.datiSimulazioniSrl.E119)}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E27"
                        label="Assimilati lav. dipendente"
                        value={Number(state.datiSimulazioniSrl.E120)}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E28"
                        label="Impr. minore/ Lav. auton."
                        value={Number(state.datiSimulazioniSrl.E121)}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E29"
                        label="Diversi lettere i) e l)"
                        value={Number(state.datiSimulazioniSrl.E122)}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E30"
                        label="Fabbricati locati"
                        value={Number(state.datiSimulazioniSrl.E123)}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E33"
                        label="Altri"
                        value={Number(state.datiSimulazioniSrl.E124)}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E34"
                        label="Abitazione principale"
                        value={Number(state.datiSimulazioniSrl.E125)}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E36"
                        label="Redditi a cedolare secca"
                        value={Number(state.datiSimulazioniSrl.E127)}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E38"
                        label="Reddito complessivo"
                        value={Number(state.normaleSimulazioniSrl.E38)}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E39"
                        label="Redd. compl. per detraz."
                        value={Number(state.normaleSimulazioniSrl.E39)}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </Grid>
                {/* <SectionSubTitle text="Previdenza"></SectionSubTitle> */}
                <Grid container>
                    <NumberField
                        name="G23"
                        label="Redditi IVS"
                        value={Number(state.normaleSimulazioniSrl.G23)}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="H23"
                        label="Contr. IVS"
                        value={Number(state.normaleSimulazioniSrl.H23)}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </Grid>
                <Grid container>
                    <NumberField
                        name="I25"
                        label="Oneri deducibili"
                        value={Number(state.normaleSimulazioniSrl.I25)}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="I26"
                        label="Reddito imponibile"
                        value={Number(state.normaleSimulazioniSrl.I26)}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="I27"
                        label="Irpef lorda"
                        value={Number(state.normaleSimulazioniSrl.I27)}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </Grid>
                <SectionTitle text="Detrazioni"></SectionTitle>
                <NumberField
                    name="I29"
                    label="Familiari a carico"
                    value={Number(state.normaleSimulazioniSrl.I29)}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I30"
                    label="Lavoro dipend."
                    value={Number(state.normaleSimulazioniSrl.I30)}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I31"
                    label="Pensione"
                    value={Number(state.normaleSimulazioniSrl.I31)}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I33"
                    label="Impresa/lav. Auton. e lav. non dipend."
                    value={Number(state.normaleSimulazioniSrl.I33)}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I34"
                    label="Altre"
                    value={Number(state.datiSimulazioniSrl.L122)}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I35"
                    label="Tot. Detrazioni"
                    value={Number(state.normaleSimulazioniSrl.I35)}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I37"
                    label="Irpef netta"
                    value={Number(state.normaleSimulazioniSrl.I37)}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                    special={true}
                />
                <SectionTitle text="Addizionali Irpef"></SectionTitle>
                <NumberField
                    name="K37"
                    label="Regionale"
                    value={Number(state.normaleSimulazioniSrl.K37)}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                    special={true}
                />
                <NumberField
                    name="M37"
                    label="Comunale"
                    value={Number(state.normaleSimulazioniSrl.M37)}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                    special={true}
                />
            </Paper>
            <Paper className={gClasses.mainPaper}>
                <SectionTitle primary={true} text="2° Socio"></SectionTitle>
                <TextField
                    name="D51"
                    label="Nome"
                    value={state.datiSimulazioniSrl.C53}
                    className={gClasses.textFieldReadOnly}
                    InputLabelProps={{
                        shrink: true,
                        disabled: true
                    }}
                    inputProps={{tabIndex: -1}}
                    margin="normal"
                />
                <SectionTitle text="Redditi"></SectionTitle>
                <Grid container>
                    <NumberField
                        name="E54"
                        label="Pensione"
                        value={Number(state.datiSimulazioniSrl.E133)}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E55"
                        label="Lav. dipendente e assimilati"
                        value={Number(state.datiSimulazioniSrl.E134)}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E58"
                        label="Assimilati lav. dipendente"
                        value={Number(state.datiSimulazioniSrl.E135)}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E59"
                        label="Impr. minore/ Lav. auton."
                        value={Number(state.datiSimulazioniSrl.E136)}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E60"
                        label="Diversi lettere i) e l)"
                        value={Number(state.datiSimulazioniSrl.E137)}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E61"
                        label="Fabbricati locati"
                        value={Number(state.datiSimulazioniSrl.E138)}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E64"
                        label="Altri"
                        value={Number(state.datiSimulazioniSrl.E139)}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E65"
                        label="Abitazione principale"
                        value={Number(state.datiSimulazioniSrl.E140)}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E67"
                        label="Redditi a cedolare secca"
                        value={Number(state.datiSimulazioniSrl.E142)}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E69"
                        label="Reddito complessivo"
                        value={Number(state.normaleSimulazioniSrl.E69)}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E70"
                        label="Redd. compl. per detraz."
                        value={Number(state.normaleSimulazioniSrl.E70)}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </Grid>
                {/* <SectionSubTitle text="Previdenza"></SectionSubTitle> */}
                <Grid container>
                    <NumberField
                        name="G54"
                        label="Redditi IVS"
                        value={Number(state.normaleSimulazioniSrl.G54)}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="H54"
                        label="Contr. IVS"
                        value={Number(state.normaleSimulazioniSrl.H54)}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </Grid>
                <Grid container>
                    <NumberField
                        name="I56"
                        label="Oneri deducibili"
                        value={Number(state.normaleSimulazioniSrl.I56)}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="I57"
                        label="Reddito imponibile"
                        value={Number(state.normaleSimulazioniSrl.I57)}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="I58"
                        label="Irpef lorda"
                        value={Number(state.normaleSimulazioniSrl.I58)}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </Grid>
                <SectionTitle text="Detrazioni"></SectionTitle>
                <NumberField
                    name="I60"
                    label="Familiari a carico"
                    value={Number(state.normaleSimulazioniSrl.I60)}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I61"
                    label="Lavoro dipend."
                    value={Number(state.normaleSimulazioniSrl.I61)}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I62"
                    label="Pensione"
                    value={Number(state.normaleSimulazioniSrl.I62)}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I64"
                    label="Impresa/lav. Auton. e lav. non dipend."
                    value={Number(state.normaleSimulazioniSrl.I64)}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I65"
                    label="Altre"
                    value={Number(state.datiSimulazioniSrl.L137)}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I66"
                    label="Tot. detrazioni"
                    value={Number(state.normaleSimulazioniSrl.I66)}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />

                <NumberField
                    name="I68"
                    label="Irpef netta"
                    value={Number(state.normaleSimulazioniSrl.I68)}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                    special={true}
                />
                <SectionTitle text="Addizionali Irpef"></SectionTitle>
                <NumberField
                    name="K68"
                    label="Regionale"
                    value={Number(state.normaleSimulazioniSrl.K68)}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                    special={true}
                />
                <NumberField
                    name="M68"
                    label="Comunale"
                    value={Number(state.normaleSimulazioniSrl.M68)}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                    special={true}
                />
            </Paper>
            <Paper className={gClasses.mainPaper}>
                <SectionTitle primary={true} text="3° Socio"></SectionTitle>
                <TextField
                    name="D82"
                    label="Nome"
                    //HACK vmorell 20210930 non è un Number
                    value={state.datiSimulazioniSrl.C54}
                    className={gClasses.textFieldReadOnly}
                    InputLabelProps={{
                        shrink: true,
                        disabled: true
                    }}
                    inputProps={{tabIndex: -1}}
                    margin="normal"
                />
                <SectionTitle text="Redditi"></SectionTitle>
                <Grid container>
                    <NumberField
                        name="E85"
                        label="Pensione"
                        value={Number(state.datiSimulazioniSrl.E147)}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E86"
                        label="Lav. dipendente e assimilati"
                        value={Number(state.datiSimulazioniSrl.E148)}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E89"
                        label="Assimilati lav. dipendente"
                        value={Number(state.datiSimulazioniSrl.E149)}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E90"
                        label="Impr. minore/ Lav. auton."
                        value={Number(state.datiSimulazioniSrl.E150)}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E91"
                        label="Diversi lettere i) e l)"
                        value={Number(state.datiSimulazioniSrl.E151)}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E92"
                        label="Fabbricati locati"
                        value={Number(state.datiSimulazioniSrl.E152)}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E95"
                        label="Altri"
                        value={Number(state.datiSimulazioniSrl.E153)}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E96"
                        label="Abitazione principale"
                        value={Number(state.datiSimulazioniSrl.E154)}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E98"
                        label="Redditi a cedolare secca"
                        value={Number(state.datiSimulazioniSrl.E156)}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E100"
                        label="Reddito complessivo"
                        value={Number(state.normaleSimulazioniSrl.E100)}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E101"
                        label="Redd. compl. per detraz."
                        value={Number(state.normaleSimulazioniSrl.E101)}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </Grid>
                {/* <SectionSubTitle text="Previdenza"></SectionSubTitle> */}
                <Grid container>
                    <NumberField
                        name="G85"
                        label="Redditi IVS"
                        value={Number(state.normaleSimulazioniSrl.G85)}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="H85"
                        label="Contr. IVS"
                        value={Number(state.normaleSimulazioniSrl.H85)}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </Grid>
                <Grid container>
                    <NumberField
                        name="I87"
                        label="Oneri deducibili"
                        value={Number(state.normaleSimulazioniSrl.I87)}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="I88"
                        label="Reddito imponibile"
                        value={Number(state.normaleSimulazioniSrl.I88)}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="I89"
                        label="Irpef lorda"
                        value={Number(state.normaleSimulazioniSrl.I89)}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </Grid>
                <SectionTitle text="Detrazioni"></SectionTitle>
                <NumberField
                    name="I91"
                    label="Familiari a carico"
                    value={Number(state.normaleSimulazioniSrl.I91)}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I92"
                    label="Lavoro dipend."
                    value={Number(state.normaleSimulazioniSrl.I92)}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I93"
                    label="Pensione"
                    value={Number(state.normaleSimulazioniSrl.I93)}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I95"
                    label="Impresa/lav. Auton. e lav. non dipend."
                    value={Number(state.normaleSimulazioniSrl.I95)}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I96"
                    label="Altre"
                    value={Number(state.datiSimulazioniSrl.L151)}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I97"
                    label="Tot. detrazioni"
                    value={Number(state.normaleSimulazioniSrl.I97)}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />

                <NumberField
                    name="I99"
                    label="Irpef netta"
                    value={Number(state.normaleSimulazioniSrl.I99)}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                    special={true}
                />

                <SectionTitle text="Addizionali Irpef"></SectionTitle>
                <NumberField
                    name="K99"
                    label="Regionale"
                    value={Number(state.normaleSimulazioniSrl.K99)}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                    special={true}
                />
                <NumberField
                    name="M99"
                    label="Comunale"
                    value={Number(state.normaleSimulazioniSrl.M99)}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                    special={true}
                />

            </Paper >
        </React.Fragment>
    );
}